import { useMutation } from "react-query";
import getMembershipAgreementUrl from "../services/getMembershipAgreementUrl";

function useGetMembershipAgreementUrl() {
  return useMutation(["get-membership-agreement-url"], getMembershipAgreementUrl);
}

export default useGetMembershipAgreementUrl;
